import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { PendingOrdersComponent } from '../pending-orders/pending-orders.component';
import { CommonModule } from '@angular/common';
import { SharedService } from '../../Shared/services/shared.service';
import { Order } from '../../Shared/interfaces/order.interface';
import { ApiResponce } from '../../Shared/interfaces/apiResponce.interface';
import { RestaurantUser } from '../../Shared/interfaces/loginUserRes.interface';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { AutoReloadService } from '../../Shared/services/auto-reload.service';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { KitcheOrder } from '../../Shared/interfaces/kitchen-orders';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TrigerToastService } from '../../Shared/services/triger-toast.service';
import { catchError, of, Subject, switchMap, takeUntil } from 'rxjs';
import { SearchService } from '../../Shared/services/search.service';
import {
  commonPermObj,
  Permission,
} from '../../Shared/interfaces/userPermission.interface';
import { BranchSelectDialogeComponent } from './branch-select-dialoge/branch-select-dialoge.component';
import { environment } from '../../../environments/environment.development';
import { PlaceOrderObj } from '../../Shared/interfaces/placeOrderMenu.interface';
import { AddUserUtility } from '../../home/add-user/addUser.utility';
import { OrderService } from '../../Shared/services/order/order.service';
import { POSRoleName } from '../../Shared/interfaces/POSroleName.interface';
import { AddUserComponent } from '../../call-center/add-user/add-user.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    PendingOrdersComponent,
    CommonModule,
    TooltipModule,
    ButtonModule,
    OverlayPanelModule,
    DialogModule,
    ReactiveFormsModule,
    InputTextModule,
    InputTextareaModule,
    AddUserComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Input() UserData: RestaurantUser | any;
  @Input() localStorageData!: any;
  @ViewChild('audioSource') audioSource!: ElementRef<HTMLAudioElement>;
  @ViewChild('searchInput') searchInput!: any;
  @ViewChild('addUserComponent') addUserComponent!: AddUserComponent;

  POSRoles!: POSRoleName;
  visibleNotiBar: boolean = false;
  toggleDropdown: boolean = false;
  pendingOrder: Order[] = [];
  orderTypIdToPermission: { [key: number]: keyof Permission } = {
    1: 'dinein_order_allow',
    2: 'takeaway_order_allow',
    3: 'delivery_order_allow',
  };
  loading: boolean = false;
  loadingShiftData: boolean = false;
  closingShift: boolean = false;
  openingShift: boolean = false;
  audioUrl: string = 'assets/audio/notification.wav';
  userInteracted: boolean = false;
  seletedTab: number = 0;
  showOpenShiftDialogue: boolean = false;
  showCloseShiftDialogue: boolean = false;
  closeCounterForm!: FormGroup;
  openCounterForm!: FormGroup;
  shiftData: any = null;
  isShiftOpened: boolean = false;
  result: boolean = false;

  shift_id!: number | null | string;
  placeOrderObj: PlaceOrderObj | null = null;

  allKitchenOrder: KitcheOrder[] = [];
  recievedOrder: KitcheOrder[] = [];
  preparingOrder: KitcheOrder[] = [];
  readyOrder: KitcheOrder[] = [];
  isUserFound: boolean = false;
  callCenterLoader: boolean = false;
  userDetail: any;
  userPermision: Permission | null = null;
  intervalId: any;
  activeAddressId: number = 0;
  showCustomerDialogExt: { show: boolean; customer: boolean; address: boolean; isEdit: boolean; editAddressId: number; phoneNumber?: string } = {
    show: false,
    customer: false,
    address: false,
    isEdit: false,
    editAddressId: 0,
  };
  constructor(
    private shared: SharedService,
    private router: Router,
    private placeOrderS: OrderService,
    private reloadS: AutoReloadService,
    private fb: FormBuilder,
    private addUserU: AddUserUtility,
    private toastS: TrigerToastService,
    private searchService: SearchService
  ) {}

  ngOnInit(): void {
    this.userPermision = this.UserData?.permissions;
    this.POSRoles = this.shared.POSRoleName;
    this.seletedTab =
      this.POSRoles.pos_dispatcher === this.UserData.rolename ? 4 : 3;
    this.loading = true;
    this.reloadS.pendingOrderNotifySubject.subscribe((Orders: Order[]) => {
      const filteredOrders = Orders.filter((order: Order) => {
        return !(this.userPermision?.[this.orderTypIdToPermission[order.order_type_id]]?.can_access === 0)
      });
      this.loading = false;
      if (filteredOrders.length > 0 && this.UserData.rolename !== 'POS Call Center') {
        this.pendingOrder = filteredOrders;
        setTimeout(() => {
          this.playAudio();
          this.visibleNotiBar = true;
        }, 500);
      }
    });
    this.reloadS.todaysKitcheOrderSubject.subscribe((kitcheOrder: any) => {
      this.allKitchenOrder = kitcheOrder;
      this.filterOrderforSeprateKitchen(kitcheOrder);
    });

    // const getLSID = localStorage.getItem('shift_id');
    this.shift_id = this.localStorageData.user.shift_id;
    if (
      this.shift_id === null &&
      this.UserData?.rolename !== 'POS Call Center'
    ) {
      this.isShiftOpened = false;
      if (
        this.UserData.rolename === this.POSRoles?.pos_dispatcher ||
        this.UserData.rolename === this.POSRoles?.pos_kitchen ||
        this.UserData.rolename === 'POS Call Center' ||
        this.UserData.rolename === 'POS Manager' ||
        this.UserData.rolename === 'POS Kitchen Manager'
      ) {
        this.showOpenShiftDialogue = false;
      } else {
        this.showOpenShiftDialogue = true;
      }
    } else {
      this.showOpenShiftDialogue = false;
      this.isShiftOpened = true;
    }

    //  open counter form

    this.openCounterForm = this.fb.group({
      opening_amount: [
        '',
        [
          Validators.required,
          Validators.min(0),
          Validators.maxLength(6),
          Validators.pattern('^[0-9]+$'),
        ],
      ],
      opening_remarks: [''],
    });
    this.startAutoRefresh();
    this.getPlaceOrderObj();
  }
  startAutoRefresh() {
    this.intervalId = setInterval(() => {
      this.reloadS.getPendingOrderApi();
    }, 180000);
  }
  ngAfterViewInit(): void {}

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    let element: HTMLElement | null = event.target as HTMLElement;
    if (element?.id == 'toggle') {
      this.toggleDropdown = !this.toggleDropdown;
    } else {
      this.toggleDropdown = false;
      if (element?.id == 'overlay') {
        this.visibleNotiBar = false;
        this.stopAudio();
      }
    }
  }

  openBranchSelectDialoge() {
    this.shared.insertData({ key: 'dialoge', val: true });
  }

  toggleSidebar() {
    this.visibleNotiBar = true;
  }

  // searachRecordbyPhone(event: any) {
  //   const phone = event.target?.value;
  //   if (phone.length > 9) {
  //     this.shared
  //       .sendGetRequest(`get_customer_by_contact?contact_no=${phone}`)
  //       .subscribe((data) => {
  //         if (data && data.Success && data.Data) {
  //           this.userDetail = data.Data ?? null;
  //           console.log(this.userDetail, 'userDetail');
  //         } else if (data && !data.Success) {
  //           this.isUserFound = false;
  //           this.userDetail = null;
  //         } else {
  //           this.userDetail = null;
  //         }
  //       });
  //   }
  // }
  getPlaceOrderObj() {
    this.placeOrderS
      .getPlaceOrderObj()

      .subscribe((data: PlaceOrderObj | null) => {
        if (data) {
          this.placeOrderObj = data;
          if (this.placeOrderObj) {
            this.userDetail = this.placeOrderObj.customer;
            this.activeAddressId = this.placeOrderObj.delivery_address_id ?? 0;
          }
        }
      });
  }
  searachRecordbyPhone() {
    const cell = this.searchInput.nativeElement.value;

    if (!cell) {
      this.searchService.searchPhoneNo(null);
    }
    if (cell.length === 11) {
      this.callCenterLoader = true;
      const url = `${this.UserData?.rolename === 'POS Call Center' ? 'get_restaurant_customer_by_contact' : 'get_customer_and_order_by_contact'}?${this.UserData?.rolename === 'POS Call Center' ? 'contact_no' : 'cell_num'}=${cell}`;

      this.shared.sendGetRequest(url).subscribe({
        next: (response: any) => {
          if (response.Success) {
            const customerData = this.UserData?.rolename === 'POS Call Center' ? response.Data : response.Data?.customer;
            this.callCenterLoader = false;
            this.activeAddressId = this.addUserU.getActiveAddressId(
              customerData,
              this.activeAddressId
            );
            if (!this.placeOrderObj) return;
            this.placeOrderObj.customer_id = customerData?.id;
            this.placeOrderObj.customer = customerData;
            if (customerData.addresses.length === 1) {
              this.placeOrderObj.delivery_address_id = customerData.addresses[0].id;
            }
            this.placeOrderS.updatePlaceOrder(this.placeOrderObj);
            this.searchService.searchPhoneNo(customerData);
            this.shared.insertData({
              key: 'previous_orders',
              val: response.Data?.previous_orders,
            });
            this.callCenterLoader = false;
            this.result = true;
            this.toastS.showToast({
              Message: 'User Found',
              shortMessage: 'Success!',
              type: 'success',
            });
          } else {
            this.callCenterLoader = false;
            this.openAddUserDialog(cell);
          }
        },
      });
    }
  }
  clearInput() {
    this.result = false;
    this.searchInput.nativeElement.value = '';
    this.searchService.searchPhoneNo(null);
    if (this.UserData?.rolename === 'POS Call Center' && this.placeOrderObj) {
      this.placeOrderObj.customer_id = null;
      this.placeOrderObj.customer = undefined;
      this.placeOrderS.updatePlaceOrder(this.placeOrderObj);
      this.shared.insertData({ key: 'previous_orders', val: [] });
    }
  }

  openAddUserDialog(phoneNumber: string) {
    this.showCustomerDialogExt = {
      show: true,
      customer: true,
      address: false,
      isEdit: false,
      editAddressId: 0,
      phoneNumber: phoneNumber,
    };
  }

  async handleLogout() {
    localStorage.clear();
    this.reloadS.todaysKitcheOrderSubject.next([]);
    this.reloadS.pendingOrderNotifySubject.next([]);
    this.reloadS.unSubscribeCounter();
    this.reloadS.unSubscribeKitchenOrders();
    this.shared.resetLocalStorageData();
    setTimeout(() => {
      this.router.navigateByUrl('/login');
    }, 0);
  }

  playAudio() {
    const audio = this.audioSource.nativeElement;
    if (audio.paused || audio.ended) {
      audio
        .play()
        .catch((error) => console.error('Error when playing audio:', error));
    }
    // audio.currentTime = 0;
    // audio.play().catch((error) => console.error('Error when playing audio:', error));
  }

  stopAudio() {
    const audio = this.audioSource.nativeElement;
    if (!audio.paused) {
      audio.pause();
      audio.currentTime = 0;
    }
    // audio.pause();
  }

  filterOrderforSeprateKitchen(orderData: KitcheOrder[]) {
    this.recievedOrder = [];
    this.preparingOrder = [];
    this.readyOrder = [];
    orderData.map((order: any) => {
      if (order.order_details[0]['order_detail_status_id'] == 2) {
        this.recievedOrder.push(order);
      } else if (order.order_details[0]['order_detail_status_id'] == 3) {
        this.preparingOrder.push(order);
      } else if (order.order_details[0]['order_detail_status_id'] == 4) {
        this.readyOrder.push(order);
      }
    });
  }

  OrderStatusTabs(order_detail_status: number) {
    if (order_detail_status == 2) {
      this.reloadS.filterOrderFlag.next(order_detail_status);
      this.seletedTab = 2;
    } else if (order_detail_status == 3) {
      this.seletedTab = 3;
      this.reloadS.filterOrderFlag.next(order_detail_status);
    } else if (order_detail_status == 4) {
      this.seletedTab = 4;
      this.reloadS.filterOrderFlag.next(order_detail_status);
    } else {
      this.seletedTab = 0;
      this.reloadS.filterOrderFlag.next(order_detail_status);
    }
  }
  resetState() {
    this.seletedTab = 9;
  }
  openShift(): void {
    if (this.openCounterForm.valid) {
      this.openingShift = true;
      const apiData = {
        opening_amount: this.openCounterForm.value.opening_amount,
        opening_remarks: this.openCounterForm.value.opening_remarks,
      };
      this.shared
        .sendPostRequest('shift_open', apiData)
        .subscribe((res: ApiResponce) => {
          if (res.Success) {
            this.shift_id = res.Data[0].id;
            const existingData = sessionStorage.getItem(
              `sharedData@${environment.appName}`
            );
            let parsedData = existingData ? JSON.parse(existingData) : {};
            parsedData.user.shift_id = this.shift_id;
            sessionStorage.setItem(
              `sharedData@${environment.appName}`,
              JSON.stringify(parsedData)
            );
            this.openingShift = false;
            this.isShiftOpened = true;
            this.openCounterForm.reset();
            this.showOpenShiftDialogue = false;
            window.location.reload();
            this.toastS.showToast({
              Message: res.Message,
              shortMessage: 'Success!',
              type: 'success',
            });
          } else {
            this.openingShift = false;
            this.toastS.showToast({
              Message: res.Message,
              shortMessage: 'Error!',
              type: 'error',
            });
          }
        });
    } else {
      this.openCounterForm.markAllAsTouched();
      this.openCounterForm.updateValueAndValidity();
    }
  }

  reloadPOSKitchenAPI() {
    this.reloadS.getTodayKitchenOrders();
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
